import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.iterator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'aggregate_search_shop_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    changeValues: function changeValues(val) {
      if (!val.includes('') && val.length === this.optionalMenuList.length) {
        this.value.config.values.unshift('');
      } else if (val.includes('') && val.length - 1 < this.optionalMenuList.length) {
        this.value.config.values = this.value.config.values.filter(function (item) {
          return item !== '';
        });
      }
      // 搜索业务中如果不包含默认功能模块 将其置空
      if (!val.includes(this.value.config.default_search_category_id)) {
        this.value.config.default_search_category_id = '';
      }
    },
    changeType: function changeType(item) {
      if (this.disabled) {
        return;
      }
      var show_type = item.show_type,
        image = item.image;
      this.value.config.show_type = show_type;
      this.value.config.image = image;
    },
    removeTag: function removeTag(val) {
      if (val === '') {
        this.value.config.values = [];
        // 搜索业务中如果不包含默认功能模块 将其置空
        this.value.config.default_search_category_id = '';
      }
    },
    selectAll: function selectAll() {
      var list = this.optionalMenuList.map(function (i) {
        return i.id;
      });
      if (this.value.config.values.length < list.length) {
        this.value.config.values = [''].concat(_toConsumableArray(list));
      } else {
        this.value.config.values = [];
        // 搜索业务中如果不包含默认功能模块 将其置空
        this.value.config.default_search_category_id = '';
      }
    }
  },
  created: function created() {
    var category_id = this.$route.query.category_id;
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    var _this$value$default_v = this.value.default_value.show_type_list,
      show_type_list = _this$value$default_v === void 0 ? [] : _this$value$default_v;
    this.$set(this.value, 'config', _objectSpread({
      show_type: show_type_list[0].show_type,
      image: show_type_list[0].image,
      // values: category_id
      // 	? [category_id]
      // 	: [''].concat(this.optionalMenuList.map(i => i.id)),
      // default_search_category_id: category_id || '',
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index
    }, this.value.config));
  },
  computed: {
    // 默认功能模块列表, 从可搜索业务中 过滤出已选中项
    // selectMenuList() {
    // 	return this.optionalMenuList.filter(i => {
    // 		return this.value.config.values.includes(i.id)
    // 	})
    // },
    // optionalMenuList() {
    // 	// 可选择的菜单
    // 	return this.menuList.filter(i => !i.disabled)
    // }
  }
  // watch: {
  // 	'value.config.values': {
  // 		handler(val) {
  // 			if (!val.includes('') && val.length === this.optionalMenuList.length) {
  // 				this.value.config.values.unshift('')
  // 			} else if (
  // 				val.includes('') &&
  // 				val.length - 1 < this.optionalMenuList.length
  // 			) {
  // 				this.value.config.values = this.value.config.values.filter(item => {
  // 					return item !== ''
  // 				})
  // 			}
  // 			// 搜索业务中如果不包含默认功能模块 将其置空
  // 			if (!val.includes(this.value.config.default_search_category_id)) {
  // 				this.value.config.default_search_category_id = ''
  // 			}
  // 		}
  // 	}
  // }
};